import { useState } from "react";

export function useAnsweredPreviewBody<TBody, TData>(options: {
    requestedBody: TBody;
    query: { isPlaceholderData: boolean; data: TData | undefined };
}): TBody {
    const [answeredBody, setAnsweredBody] = useState(options.requestedBody);
    if (
        !options.query.isPlaceholderData &&
        options.query.data !== undefined &&
        answeredBody !== options.requestedBody
    ) {
        setAnsweredBody(options.requestedBody);
    }
    return answeredBody;
}
